import { render, staticRenderFns } from "./categorization_selector.vue?vue&type=template&id=0b7f6427&"
import script from "./categorization_selector.vue?vue&type=script&lang=js&"
export * from "./categorization_selector.vue?vue&type=script&lang=js&"
import style0 from "./categorization_selector.vue?vue&type=style&index=0&id=0b7f6427&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports